(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["serenepet-header"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-sp-menu]').forEach(menu=>{
  menu.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.open){menu.open=false;menu.querySelector('summary').focus();}});
  document.addEventListener('click',event=>{if(menu.open&&!menu.contains(event.target))menu.open=false;});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["serenepet-reviews"] && !Shopify.designMode) return;
  try {
    function initializeSerenePetReviews(root){
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const grid=root.querySelector('[data-sr-grid]');
  const pending=root.querySelector('[data-sr-pending]');
  const more=root.querySelector('[data-sr-more]');
  const progress=root.querySelector('[data-sr-progress]');
  more?.addEventListener('click',()=>{
    const next=[...pending.content.querySelectorAll('[data-sr-card]')].slice(0,Number(root.dataset.srPageSize)||20);
    next.forEach(card=>grid.append(card));
    const first=next[0];
    if(first){first.tabIndex=-1;first.focus({preventScroll:true});first.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
    const shown=grid.querySelectorAll('[data-sr-card]').length;
    progress.textContent=`${progress.dataset.srLabel} ${shown} / ${progress.dataset.srTotal}`;
    more.hidden=!pending.content.querySelector('[data-sr-card]');
  });
  const dialog=root.querySelector('[data-sr-photo-dialog]');
  root.addEventListener('click',event=>{
    const button=event.target.closest('[data-sr-image]');
    if(button){const image=dialog.querySelector('[data-sr-large-photo]');image.src=button.dataset.srFull;image.alt=button.querySelector('img')?.alt||'';dialog.showModal();}
  });
  dialog.querySelector('[data-sr-photo-close]')?.addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  const section=root.closest('.shopify-section');
  section?.addEventListener('shopify:block:select',event=>{const selected=pending.content.querySelector(`[data-block-id="${CSS.escape(event.detail.blockId)}"]`);if(selected){grid.append(selected);selected.scrollIntoView({block:'center'});const shown=grid.querySelectorAll('[data-sr-card]').length;progress.textContent=`${progress.dataset.srLabel} ${shown} / ${progress.dataset.srTotal}`;more.hidden=!pending.content.querySelector('[data-sr-card]');}});
}
document.querySelectorAll('[data-sr-reviews]').forEach(initializeSerenePetReviews);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sr-reviews]').forEach(initializeSerenePetReviews));
  } catch(e) { console.error(e); }
})();

})();
